import { render, staticRenderFns } from "./appointOrderDetail.vue?vue&type=template&id=f0babdf2&scoped=true&"
import script from "./appointOrderDetail.vue?vue&type=script&lang=js&"
export * from "./appointOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./appointOrderDetail.vue?vue&type=style&index=0&id=f0babdf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0babdf2",
  null
  
)

export default component.exports